import { BlockContent } from '~/components/BlockContent'
import { EventData } from '~/gamification/types/gamification.types'
import { QuestMetadata } from '~/types/quest'

import ExpandButton from './ExpandButton'

export default function CollectionItem({
  data,
  completed = [],
  onClick,
  id,
  className,
}: {
  data?: QuestMetadata[]
  completed: EventData[]
  onClick: () => void
  id: string
  className: string
}): React.ReactElement {
  const disableClassName = 'opacity-10'
  const isUnlocked = completed.find((unlock) => unlock.id === id)
  const questData = data?.find((quest) => quest.questId === id)
  const unlockedClassName = isUnlocked ? 'hover:cursor-pointer' : disableClassName

  const onItemClick = (): void => {
    if (isUnlocked) onClick()
    else return
  }

  return (
    <div className={`${unlockedClassName} bg-white rounded px-1 py-0.5 mb-auto`} onClick={onItemClick}>
      {questData && questData.trophy && questData.shadowTrophy && (
        <div className={className}>
          <div className="max-h-11">
            {isUnlocked ? (
              <BlockContent blocks={[questData.trophy]} />
            ) : (
              <BlockContent blocks={[questData.shadowTrophy]} />
            )}
          </div>
          <ExpandButton disabled={!isUnlocked} />
        </div>
      )}
    </div>
  )
}
